import { ContainerModule } from 'inversify';
import { ZoomableService, ZoomableServiceSymbol } from './zoomable-service';

export const zoomableModule = new ContainerModule((bind) => {
  bind<ZoomableService>(ZoomableServiceSymbol).to(ZoomableService).inSingletonScope();
});
